import { format as format$1, parseISO } from 'date-fns';
/**
 * Uses date-fns format function to get a formatted version of a date.
 * If an Invalid Date type of value is supplied, the function will default to a new Date() object.
 *
 * @param date {string} A string representation of a valid date accepted by the Date object constructor.
 * @param format {string} Refer to date-fns's format function.
 * @param options {object} Refer to date-fns's format function.
 * @returns
 */

var format = function format(date, _format, options) {
  if (isNaN(Date.parse(date))) {
    // not a valid date
    return format$1(new Date(), _format, options);
  } // if it's a string, parse it with ISO format first to support all browsers and timezones


  var normalizedDate = typeof date === 'string' ? parseISO(date.replace(/\//g, '-')) : date;
  return format$1(normalizedDate, _format, options);
};

export { format };